'use client';

import { T } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';
import { css } from '@flipster/styled-system/css';
import { center, hstack, vstack } from '@flipster/styled-system/patterns';

import CopyTradingIcon from '../../assets/copy-trading.webp';

export const MasterTraderIntro = () => {
  return (
    <section
      className={css({
        w: '100%',
        background:
          'linear-gradient(180deg, token(colors.background.accent.primary.tint), token(colors.background.accent.primary.tint/0))',
      })}
    >
      <div
        className={css({
          w: '100%',
          maxW: 'desktopMaxWidth',
          mx: 'auto',
          pt: { base: 60, tablet: 80, smallDesktop: 170 },
          pb: { base: 60, tablet: 80, smallDesktop: 120 },
          px: { base: 20, tablet: 40, smallDesktop: 0 },
        })}
      >
        <div
          className={hstack({
            gap: 24,
            alignItems: 'center',
            flexDir: { base: 'column-reverse', tablet: 'row' },
          })}
        >
          <div className={vstack({ gap: 20, alignItems: 'flex-start', maxW: { base: '100%', tablet: 560 } })}>
            <h1 className={css({ textStyle: 'Display/XL', color: 'content.default.level-5' })}>
              <T id='Copy.r260127.Become_a_master_trader_of_copy_trading' />
            </h1>

            <p className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3' })}>
              <T id='Copy.r260129.Flipster_is_selecting_a_small_group_of_elite_master_traders_for_copy_trading' />
            </p>

            <Button
              as='button'
              label={<T id='Copy.r260127.Apply_button' />}
              size='large'
              onClick={() => {
                const formSection = document.getElementById('apply-form-section');
                if (!formSection) return;
                requestAnimationFrame(() => formSection.scrollIntoView({ block: 'center', behavior: 'smooth' }));
              }}
              css={{ tablet: { minW: 200 } }}
            />
          </div>
          <div
            className={center({
              ml: { base: 0, tablet: 'auto' },
              w: { base: '100%', tablet: '40%' },
              h: { base: 300, tablet: 404 },
            })}
          >
            <img src={CopyTradingIcon.src} height='100%' alt='Copy Trading' />
          </div>
        </div>
      </div>
    </section>
  );
};
